import React from 'react';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid2';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';
import PlayIcon from '@mui/icons-material/PlayArrow';
import { useTranslation } from 'react-i18next';

const Controls = ({ onClear, onPause, onFinish, recording, recordInProgress }) => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={3} display="flex" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
            <Grid xs display="flex" justifyContent="center" alignItems="center">
                <Fab
                    data-testid="control-clear"
                    color="info"
                    sx={{ width: 56, height: 56 }}
                    aria-label={t('clearRecording')}
                    onClick={onClear}
                >
                    <ClearIcon sx={{ width: 24, height: 24, color: 'white' }} />
                </Fab>
            </Grid>
            <Grid xs display="flex" justifyContent="center" alignItems="center">
                <Fab
                    data-testid="control-pause"
                    color="info"
                    sx={{ width: 56, height: 56 }}
                    aria-label={recording ? t('paused') : t('resumeRecording')}
                    onClick={onPause}
                >
                    {recording
                        ? <PauseIcon sx={{ width: 24, height: 24, color: 'white' }} />
                        : <PlayIcon sx={{ width: 24, height: 24, color: 'white' }} />
                    }
                </Fab>
            </Grid>
            <Grid xs display="flex" justifyContent="center" alignItems="center">
                <Fab
                    data-testid="control-done"
                    sx={{ width: 56, height: 56 }}
                    color="info"
                    aria-label={t('done')}
                    onClick={onFinish}
                >
                    <CheckIcon sx={{ width: 24, height: 24, color: 'white' }} />
                </Fab>
            </Grid>
        </Grid>
    );
};

export default Controls;
